<div 
    class="cea-page-container" 
    id="wrap" 
    [ngClass]="{'admin-page': router.url.includes('\admin'), 'widget-wrap' : getIsWidget()}">
    <div id="primary-container">
        <router-outlet></router-outlet>
    </div>
</div>